const forms = {
  "webinar-sso": {
    title: [
      "Webinar:",
      "How Instant-Intake with Single Sign On will effect Healthcare",
    ],
    subtitle: [
      "Transform Your Patient Care: Discover the Power of Single Sign-On to Elevate Security and Streamline Experience",
      "",
    ],
    dates: ["May 20th", "11:00am CST"],
    form: "https://us.bigin.online/valid/forms/webinar-sso",
    formHeight: 500,
    cardsTitle: "Intake Done Better",
    cardsSubtitle:
      "Discover how Valid can revolutionize patient onboarding for your healthcare organization or practice.",
  },
  "webinar-sso": {
    title: ["Webinar:", "How patient Instant-Intake in will effect Healthcare"],
    subtitle: [
      "Transform Your Patient Care: Discover the Power of Single Sign-On to Elevate Security and Streamline Experience",
      "",
    ],
    dates: ["May 20th", "11:00am CST"],
    form: "https://us.bigin.online/valid/forms/webinar-sso",
    formHeight: 500,
    cardsTitle: "Intake Done Better",
    cardsSubtitle:
      "Discover how Valid can revolutionize patient onboarding for your healthcare organization or practice.",
  },
  "waiting-list": {
    title: ["Be the first to know:"],
    subtitle: [
      "Join the Waiting List. You will be the first to know. ",
      "We will keep you up to date on our progress",
    ],
    form: "https://us.bigin.online/valid/forms/waiting-list",
    formHeight: 500,
    cardsTitle: "Stay Ahead in Healthcare",
    cardsSubtitle:
      "Be the first to discover innovative solutions for patient care and data security.",
  },
  waiting_list: {
    klaviyoID: "U8ZAwV",
    title: ["Be the first to know:"],
    subtitle: [
      "Join the Waiting List. You will be the first to know. ",
      "We will keep you up to date on our progress",
    ],
    form: "https://us.bigin.online/valid/forms/waiting-list",
    formHeight: 500,
    cardsTitle: "Stay Ahead in Healthcare",
    cardsSubtitle:
      "Be the first to discover innovative solutions for patient care and data security.",
  },
  contact: {
    title: ["Contact Us"],
    subtitle: [
      "Absolutely! We're thrilled to connect with you.",
      " Here's how you can reach us:",
      "",
      "Email: support@valid.care",
    ],
    form: "https://us.bigin.online/valid/forms/waiting-list",
    formHeight: 500,
    cardsTitle: "Stay Ahead in Healthcare",
    cardsSubtitle:
      "Be the first to discover innovative solutions for patient care and data security.",
  },
};

export default forms;
